class CareerUploadFile  {
  constructor() {
    this.formContainer = document.querySelector('.career-form')
    if (this.formContainer) {
      this.uploadBtn = this.formContainer.querySelector('#upload-file')
      if (this.uploadBtn) {
        this.listen()
      }
    }
  }
  listen() {
    this.uploadBtn.addEventListener('change', (ev)=> {
      const files = ev.target.files;
      const fileName = files[0].name;
      this.formContainer.querySelector('.career-form__input .button').dataset.before = ''
      this.formContainer.querySelector('.career-form__input .button').innerText = ''
      this.formContainer.querySelector('.career-form__input .button').innerHTML = fileName
    })
  }
}

export default CareerUploadFile;